/* eslint-disable no-invalid-this */
/*
 * @Description: 头部注释: ...
 * @Version: 1.0.0
 * @Autor: michael_jier
 * @Date: 2021-06-28 17:44:49
 * @LastEditors: michael_jier
 * @LastEditTime: 2021-09-14 11:41:45
 */
/**
 * 登录
 * @param {object} {token}
 * return Pomise
 */
  import { getWatchLoginInfo } from '@/api/apiAll';
  import Cookie from 'js-cookie'
  import { watchTime } from "@/api/apiWS";

  export default async function({token, onFinished} = {token: ''}) {
    const store = this.$store
    token && Cookie.set('token', token, { expires: 10 });
    const { id, uin, liveStatus } = store.getters['channelInfo']
    console.log(store, 333333333);
    const res = await getWatchLoginInfo({
      id, uin
    });
    if (res.code === 200 && res.errorCode === 0) {
      const info = res.data.watchUserInfo
      store.commit('set_userInfo', info);
      const channelInfo = JSON.parse(JSON.stringify(store.state.channelInfo));
      channelInfo.watchNum = res.data.watchNum;
      store.commit('set_channelInfo', channelInfo);
      // 数据统计相关
      store.dispatch('PostInfo')
      const websocketHeartbeat = require('../timer.js').default;
      const websocketInfo = {
        "userId": info.id || 0,
        //  "token": this.token,
        "id": id,
        "type":"radio",
        "uin": uin,
        "liveNowStatus": liveStatus
      }
      const timer = websocketHeartbeat({
        url: watchTime,
        pingTimeout: 5000,
        pongTimeout: 5000,
        manualStart: false,
        repeatLimit: 10,
        userInfo: websocketInfo,
        webworker: false
      }).useIt('uuid').useIt('ua')
      this.set_uuid(timer.uuid);
      onFinished && onFinished()
    }
    return this
  }
